export const JUMP_RULES = {
  launchSpeed: 6,
  gravity: 18,
  stepClearance: 0.05,
} as const;
